module.exports = __webpack_public_path__ + "static/media/img3.6182a45f.jpg";